
import { RecipeCard } from "./RecipeCard";
import { Clock, Thermometer } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";

interface RecipeOverviewProps {
  prepTime?: string;
  cookTime?: string;
  temperature?: string;
}

export const RecipeOverview = ({ prepTime, cookTime, temperature }: RecipeOverviewProps) => {
  const totalTime = prepTime && cookTime 
    ? `${parseInt(prepTime) + parseInt(cookTime)} minutes`
    : undefined;
  const isMobile = useIsMobile();

  return (
    <RecipeCard title="Recipe Overview" icon="📋">
      <div className={`grid ${isMobile ? 'grid-cols-1' : 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-4'} gap-6`}>
        {prepTime && (
          <div className="flex items-center gap-3">
            <Clock className="h-5 w-5 text-purple-500 shrink-0" />
            <div className="min-w-0 flex-1">
              <p className="font-medium text-sm sm:text-base">Preparation Time</p>
              <p className="text-gray-600 text-sm">{prepTime} minutes</p>
            </div>
          </div>
        )}
        
        {cookTime && (
          <div className="flex items-center gap-3">
            <Clock className="h-5 w-5 text-orange-500 shrink-0" />
            <div className="min-w-0 flex-1">
              <p className="font-medium text-sm sm:text-base">Cooking Time</p>
              <p className="text-gray-600 text-sm">{cookTime} minutes</p>
            </div>
          </div>
        )}
        
        {totalTime && (
          <div className="flex items-center gap-3">
            <Clock className="h-5 w-5 text-blue-500 shrink-0" />
            <div className="min-w-0 flex-1">
              <p className="font-medium text-sm sm:text-base">Total Time</p>
              <p className="text-gray-600 text-sm">{totalTime}</p>
            </div>
          </div>
        )}

        {temperature && (
          <div className="flex items-center gap-3">
            <Thermometer className="h-5 w-5 text-red-500 shrink-0" />
            <div className="min-w-0 flex-1">
              <p className="font-medium text-sm sm:text-base">Temperature</p>
              <p className="text-gray-600 text-sm">{temperature}</p>
            </div>
          </div>
        )}
      </div>
    </RecipeCard>
  );
};
